"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_bootstrap_1 = require("react-bootstrap");
const file_saver_1 = __importDefault(require("file-saver"));
const SankeyUtils_1 = require("open-sankey/dist/SankeyUtils");
const SankeyLayout_1 = require("open-sankey/dist/SankeyLayout");
const SupplyUseModelisationProd = ({ show_reconciliation, set_show_reconciliation, action_type, sankey_data, set_sankey_data, callback }) => {
    const [result, setResult] = react_1.useState('');
    const [processing, setProcessing] = react_1.useState(false);
    const [failure, setFailure] = react_1.useState(false);
    const [not_started, setNotStarted] = react_1.useState(true);
    const [value, setValue] = react_1.useState([1, 2]);
    const [regions, setRegions] = react_1.useState(false);
    // const [action_type,setActionType] = useState('optim')
    const [uncertainty, setUncertainty] = react_1.useState(false);
    const [nb_realizations, setNbRealizations] = react_1.useState(100);
    const [excel_file, setExcelFile] = react_1.useState('');
    const [input_file_name, setInputFileName] = react_1.useState('');
    const [layout_file, set_layout_file] = react_1.useState(undefined);
    const [input_file, set_input_file] = react_1.useState(undefined);
    //let input_file_ =  useRef<HTMLInputElement>(null)
    let upper_level_file_ = react_1.useRef(null);
    //let layout_file_=  useRef<HTMLInputElement>(null)
    //let layout_file_: Blob[] | undefined
    const setNbRealisations = (e) => {
        setNbRealizations(e.target.value);
    };
    const uncertaintyChange = (e) => {
        setUncertainty(e.target.checked);
    };
    const handleChange = (evt) => {
        if (value.includes(+evt.target.value)) {
            value.splice(value.indexOf(evt.target.value));
        }
        else {
            value.push(+evt.target.value);
        }
        setValue([...value]);
    };
    const regionChange = (evt) => {
        setRegions(evt.target.checked);
    };
    const setInputFile = (evt) => {
        set_input_file(evt.target.files[0]);
    };
    const setLayoutFile = (evt) => {
        set_layout_file(evt.target.files[0]);
    };
    const setRegionFile = (evt) => {
        upper_level_file_ = evt.target.files[0];
    };
    const retrievesResults = () => {
        //const { action_type, excel_file } = this.state
        const path = window.location.href;
        const url = path + 'sankeytools/optimize_retrieves_result';
        const form_data = new FormData();
        form_data.append('excel_file', excel_file);
        const fetchData = {
            method: 'POST',
            body: form_data
        };
        //const input_file_name = (input_file_.current as any).name 
        const root_file_name = input_file_name.split('.')[0];
        let suffix = '_reconciled.xlsx';
        if (action_type.current === 'check_excel') {
            suffix = '_corrected.xlsx';
        }
        else if (action_type.current === 'create_empty_ter') {
            suffix = '_ter_created.xlsx';
        }
        const file_name = root_file_name + suffix;
        function showFile(blob) {
            const newBlob = new Blob([blob], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            if (action_type.current === 'optim_sankey') {
                return newBlob;
            }
            file_saver_1.default.saveAs(newBlob, file_name);
            return newBlob;
        }
        // const layout = Object.assign({},sankey_data)
        fetch(url, fetchData).then(function (response) {
            if (response.ok) {
                if (action_type.current === 'check_excel') {
                    if (response.status === 201) {
                        return;
                    }
                    response.blob().then(showFile);
                }
                else {
                    response.blob()
                        .then(showFile)
                        .then((blob) => {
                        if (layout_file !== undefined) {
                            const reader = new FileReader();
                            reader.onload = (() => {
                                return ((e) => {
                                    let result = e.target.result;
                                    if (result) {
                                        result = String(result).split('<br>').join('\\\\n');
                                        const layout = JSON.parse(result);
                                        sankey_data.layout = layout;
                                    }
                                });
                            });
                            reader.readAsText(layout_file);
                        }
                        const root = window.location.href;
                        const url = root + 'sankeytools/sankey/upload_excel_old';
                        const form_data = new FormData();
                        form_data.append('file', blob);
                        const fetchData = {
                            method: 'POST',
                            body: form_data
                        };
                        fetch(url, fetchData).then(response => {
                            response.text().then(text => {
                                try {
                                    const server_data = JSON.parse(text);
                                    const error = server_data['error'];
                                    if (error && error.length != 0) {
                                        alert(error);
                                        return;
                                    }
                                    const layout = JSON.parse(JSON.stringify(sankey_data));
                                    Object.assign(sankey_data, SankeyUtils_1.processExample(server_data));
                                    if (action_type.current === 'optim_sankey') {
                                        SankeyLayout_1.updateLayout(sankey_data, layout, ['posNode', 'attrNode', 'attrFlux', 'tagNode', 'tagFlux', 'attrGeneral']);
                                    }
                                    callback(sankey_data);
                                    set_sankey_data(Object.assign({}, sankey_data));
                                }
                                catch (err) {
                                    alert(err);
                                }
                            });
                        });
                        set_show_reconciliation(false);
                        // uploadExcelImpl(
                        //   sankey_data,
                        //   set_sankey_data,
                        //   ()=> 0, 
                        //   blob, 
                        //   '/opensankey/', (new_sankey_data:AFMSankeyData)=>{
                        //     callback(new_sankey_data)
                        //     setNotStarted(true)
                        //     set_show_reconciliation(false)
                        //     return
                        //   }
                        // )
                    });
                }
            }
            else {
                response.json().then(function (data) {
                    setResult(data.output);
                    setFailure(true);
                }).catch(function () {
                    setResult(result + '\n ERROR: optimize_retrieves_result a retourné une erreur qui n\'est pas en format json');
                    setFailure(true);
                });
                action_type.current = '';
                setNotStarted(true);
            }
        });
    };
    const reset = () => {
        setProcessing(false);
        setFailure(false);
        setNotStarted(true);
    };
    // const prodProcessResponse = (response:any) => {
    //   // var {result } = this.state
    //   // var that = this
    //   if(response.ok) {
    //     response.json().then(function (data:any) {
    //       setResult(data.output)
    //       setFailure(false)
    //     })
    //   } else {
    //     response.json().then(function (data:any) {
    //       setResult(data.output)
    //       setFailure(true)
    //     }).catch( function() {
    //       setResult(result + '\n ERROR: optimize_prod_process a retourné une erreur qui n\'est pas en format json')
    //       setFailure(true)
    //     })
    //   }
    // }
    const launchReconciliation = () => {
        //var { action_type,uncertainty,nb_realizations} = this.state
        const data = new FormData();
        data.append('input_file', input_file);
        data.append('optim_sankey', String(action_type.current === 'optim_sankey'));
        data.append('create_empty_ter', String(action_type.current === 'create_empty_ter'));
        data.append('check_excel', String(action_type.current === 'check_excel'));
        data.append('uncertainty_analysis', String(uncertainty));
        data.append('nb_realizations', String(nb_realizations));
        data.append('upper_level_file', upper_level_file_.name);
        if (action_type.current === 'optim_sankey') {
            const new_sankey_data = JSON.parse(JSON.stringify(sankey_data));
            new_sankey_data.icon_catalog = {};
            data.append('sankey_data', JSON.stringify(new_sankey_data));
        }
        const path = window.location.href;
        const url = path + 'sankeytools/optimize_prod_launch';
        const fetchData = {
            method: 'POST',
            body: data
        };
        // var that = this
        fetch(url, fetchData).then(function (response) {
            if (response.ok) {
                response.json().then(function (data) {
                    setExcelFile(data['excel_input_file']);
                });
            }
        });
        setProcessing(true);
        setFailure(true);
        setNotStarted(false);
        setResult('');
        if (input_file) {
            setInputFileName(input_file.name);
        }
    };
    const finishReconciliation = (failure) => {
        //const { result} = this.state
        const path = window.location.href;
        // var url = path + 'optimize_prod_process'
        // var fetchData = {
        //   method: 'POST',
        //   body: ''
        // }
        // fetch(url, fetchData).then(that.prodProcessResponse).catch(function() {
        //   that.setState({ 
        //     result: result + '\n ERROR: optimize_prod_process: erreur fatale.',
        //     failure : true 
        //   })
        // })
        const url = path + 'sankeytools/optimize_prod_clean';
        const fetchData = {
            method: 'POST',
            body: ''
        };
        fetch(url, fetchData).then(function (response) {
            if (!response.ok) {
                setResult(result + '\n ERROR: optimize_prod_clean a retourné une erreur qui n\'est pas en format json');
                setFailure(true);
            }
            else {
                setProcessing(false);
                setFailure(failure);
                setNotStarted(false);
            }
        }).catch(function () {
            setResult(result + '\n ERROR: optimize_prod_clean: erreur fatale.');
            setFailure(true);
            // that.setState({
            //   processing : false,
            //   failure : false
            // })
            //     })
            //     } else {
            //       response.json().then(function (data) {
            //         that.setState(
            //           { result: result + data.output,
            //             processing : false,
            //             failure : true
            //           })
            //       }).catch(function() {
            //         that.setState(
            //           { result: result + '\n Le serveur a retourné une erreur qui n\'est pas en format json' ,
            //             processing : false,
            //             failure : true
            //           })
            //       })
            //     }
            //   }
            // ).catch(function() {
            //   that.setState(
            //     { result: result + '\n ERROR: optimize_prod_launch: erreur fatale.',
            //       processing : false,
            //       failure : true 
            //     })
            // })
        });
        if (action_type.current === 'optim_sankey') {
            retrievesResults();
            set_show_reconciliation(false);
        }
    };
    //var {result,processing,value,failure,not_started,regions,uncertainty,nb_realizations } = this.state
    const infos = result !== undefined ? result.split('\n') : [];
    //const { action_type } = this.state
    let title = 'Réconciliation des données';
    if (action_type.current === 'check_excel') {
        title = 'Vérification du fichier d\'entrée';
    }
    else if (action_type.current === 'create_empty_ter') {
        title = 'Création de la table Ressources Emplois';
    }
    let success_status = 'Succés de la réconciliation';
    if (action_type.current === 'check_excel') {
        success_status = 'Vérification terminée';
    }
    else if (action_type.current === 'create_empty_ter') {
        success_status = 'Création Terminée';
    }
    let failure_status = 'Echec de la réconciliation';
    if (action_type.current === 'check_excel') {
        failure_status = 'Echec de la vérification';
    }
    else if (action_type.current === 'create_empty_ter') {
        failure_status = 'Echec de la création';
    }
    react_1.useEffect(() => {
        if (not_started && action_type.current === 'optim_sankey') {
            launchReconciliation();
        }
    });
    return (react_1.default.createElement(react_bootstrap_1.Modal, { bsSize: "large", show: show_reconciliation, onHide: () => set_show_reconciliation(false), style: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
        } },
        react_1.default.createElement(react_bootstrap_1.Modal.Header, { closeButton: true },
            react_1.default.createElement(react_bootstrap_1.Modal.Title, null, "Reconciliation")),
        react_1.default.createElement(react_bootstrap_1.Modal.Body, null,
            react_1.default.createElement(react_bootstrap_1.Form, null,
                react_1.default.createElement(react_bootstrap_1.FormGroup, null,
                    action_type.current !== 'optim_sankey' ? (react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement(react_bootstrap_1.Row, null,
                            react_1.default.createElement(react_bootstrap_1.Col, { sm: 12 },
                                react_1.default.createElement("h3", { style: { textAlign: 'center' } }, "Param\u00E9tres et donn\u00E9es d'entr\u00E9e"))),
                        react_1.default.createElement(react_bootstrap_1.Row, null,
                            react_1.default.createElement(react_bootstrap_1.Col, null,
                                react_1.default.createElement("p", { style: { textAlign: 'left' } }, "Fichier d'entr\u00E9e excel")),
                            react_1.default.createElement(react_bootstrap_1.Col, null,
                                react_1.default.createElement(react_bootstrap_1.Form.Control, { type: "file", 
                                    //ref={input_file_}                
                                    name: "", onChange: setInputFile }))),
                        react_1.default.createElement(react_bootstrap_1.Row, null,
                            react_1.default.createElement(react_bootstrap_1.Col, null,
                                react_1.default.createElement(react_bootstrap_1.Form.Label, null, "Diagramme de mise en page")),
                            react_1.default.createElement(react_bootstrap_1.Col, null,
                                react_1.default.createElement(react_bootstrap_1.Form.Control, { type: "file", 
                                    //ref={layout_file_}                
                                    name: "", onChange: setLayoutFile }))))) : (react_1.default.createElement(react_1.default.Fragment, null)),
                    action_type.current === 'optim' ? (react_1.default.createElement(react_bootstrap_1.Row, null,
                        react_1.default.createElement(react_bootstrap_1.Col, { sm: 3 },
                            react_1.default.createElement(react_bootstrap_1.FormCheck, { type: 'checkbox', name: "regions", value: '0', id: "regions", label: "Descente d'\u00E9chelle", onChange: regionChange })))) : (react_1.default.createElement("div", null)),
                    regions && action_type.current === 'optim' ? (react_1.default.createElement(react_bootstrap_1.Row, null,
                        react_1.default.createElement(react_bootstrap_1.Col, { sm: 3 },
                            react_1.default.createElement("p", { style: { textAlign: 'left' } }, "Fichier MFA du niveau g\u00E9ographique sup\u00E9rieur")),
                        react_1.default.createElement(react_bootstrap_1.Col, { sm: 3 },
                            react_1.default.createElement(react_bootstrap_1.FormControl, { type: "file", name: "", onChange: setRegionFile })))) : (react_1.default.createElement("div", null)),
                    action_type.current === 'optim' ? (react_1.default.createElement(react_bootstrap_1.Row, null,
                        react_1.default.createElement(react_bootstrap_1.Col, { sm: 3 },
                            react_1.default.createElement(react_bootstrap_1.FormCheck, { type: 'checkbox', name: "uncertainty", checked: uncertainty, id: "uncertainty", label: 'Analyse d\'incertitude', onChange: uncertaintyChange })))) : (react_1.default.createElement("div", null)),
                    uncertainty && action_type.current === 'optim' ? (react_1.default.createElement(react_bootstrap_1.Row, null,
                        react_1.default.createElement(react_bootstrap_1.Col, { sm: 3 },
                            react_1.default.createElement("p", { style: { textAlign: 'left' } }, "Nombre de r\u00E9alisations")),
                        react_1.default.createElement(react_bootstrap_1.Col, { sm: 3 },
                            react_1.default.createElement(react_bootstrap_1.FormControl, { disabled: !uncertainty, value: nb_realizations, type: "text", name: "", onChange: setNbRealisations })))) : (react_1.default.createElement("div", null)),
                    react_1.default.createElement("hr", null),
                    react_1.default.createElement(react_bootstrap_1.Row, null,
                        react_1.default.createElement(react_bootstrap_1.Col, { sm: 12 },
                            react_1.default.createElement("h3", { style: { textAlign: 'center' } }, title))),
                    react_1.default.createElement("br", null),
                    react_1.default.createElement("br", null),
                    react_1.default.createElement("br", null),
                    react_1.default.createElement(react_bootstrap_1.Row, null,
                        react_1.default.createElement(react_bootstrap_1.Col, { sm: 2 }, not_started ? (react_1.default.createElement(react_bootstrap_1.Button, { variant: "primary", onClick: launchReconciliation }, "Lancer")) :
                            processing ? (react_1.default.createElement(react_bootstrap_1.Button, { variant: "warning" },
                                react_1.default.createElement("span", { className: "glyphicon glyphicon-refresh glyphicon-refresh-animate" }),
                                " En traitement...")) : (failure ?
                                react_1.default.createElement(react_bootstrap_1.Button, { variant: "danger", onClick: reset }, failure_status) :
                                react_1.default.createElement(react_bootstrap_1.Button, { variant: "success", onClick: retrievesResults }, success_status)))),
                    !not_started && !processing && !failure ? (react_1.default.createElement(react_bootstrap_1.Row, null,
                        react_1.default.createElement(react_bootstrap_1.Col, { sm: 12 },
                            react_1.default.createElement(react_bootstrap_1.Alert, null, "Cliquer pour t\u00E9l\u00E9charger les r\u00E9sultats.")))) : (react_1.default.createElement("div", null)),
                    react_1.default.createElement("hr", null),
                    react_1.default.createElement(react_bootstrap_1.Row, null,
                        react_1.default.createElement(react_bootstrap_1.Col, { sm: 12 },
                            react_1.default.createElement("h3", { style: { textAlign: 'center' } }, "Terminal"))),
                    react_1.default.createElement("br", null),
                    react_1.default.createElement("br", null),
                    react_1.default.createElement(react_bootstrap_1.Row, null,
                        react_1.default.createElement(react_bootstrap_1.Col, { sm: 12 },
                            react_1.default.createElement(react_bootstrap_1.ButtonGroup, null,
                                react_1.default.createElement(react_bootstrap_1.Button, { onClick: evt => handleChange(evt), value: 1, variant: value.includes(1) ? 'info' : 'light' }, "Infos"),
                                react_1.default.createElement(react_bootstrap_1.Button, { onClick: evt => handleChange(evt), value: 2, variant: value.includes(2) ? 'danger' : 'light' }, "Erreurs"),
                                react_1.default.createElement(react_bootstrap_1.Button, { onClick: evt => handleChange(evt), value: 3, variant: value.includes(3) ? 'warning' : 'light' }, "Debug")))),
                    processing ? (react_1.default.createElement(Counter, { finishReconciliation: finishReconciliation, value: value, result: result, setResult: setResult })) : (react_1.default.createElement(react_bootstrap_1.Row, null,
                        react_1.default.createElement(react_bootstrap_1.Col, { sm: 12 }, infos.map((info) => (value.includes(2) && info.includes('ERROR') ?
                            (react_1.default.createElement("div", { style: { color: 'red' } }, info.replace('ERROR', '')))
                            : value.includes(1) && info.includes('INFO') && !info.includes('POST') ?
                                (react_1.default.createElement("div", { style: { color: 'blue' } }, info.replace('INFO', '')))
                                : value.includes(3) && (info.includes('DEBUG')) ?
                                    (react_1.default.createElement("div", { style: { color: 'orange' } }, info.replace('DEBUG', ''))) : (null)))))))))));
};
const Counter = ({ finishReconciliation, value, result, setResult }) => {
    react_1.useEffect(() => {
        const interval = setInterval(() => {
            const path = window.location.href;
            const url = path + 'sankeytools/optimize_prod_process';
            const fetchData = {
                method: 'POST',
                body: ''
            };
            fetch(url, fetchData).then(function (response) {
                if (response.ok) {
                    response.json().then(function (data) {
                        setResult(data.output);
                    });
                }
            });
        }, 5000);
        return () => clearInterval(interval);
    });
    //let {value, result} = parent
    const infos = result !== undefined ? result.split('\n') : [];
    if (infos.length > 2) {
        const info = infos[infos.length - 2];
        if (info.includes('FINISHED')) {
            finishReconciliation(false);
        }
        else if (info.includes('FAILED')) {
            finishReconciliation(true);
        }
    }
    return (react_1.default.createElement(react_bootstrap_1.Row, null,
        react_1.default.createElement(react_bootstrap_1.Col, { sm: 12 }, infos.map(info => (value.includes(2) && info.includes('ERROR') ?
            (react_1.default.createElement("div", { style: { color: 'red' } }, info.replace('ERROR', '')))
            : value.includes(1) && info.includes('INFO') && !info.includes('POST') ?
                (react_1.default.createElement("div", { style: { color: 'blue' } }, info.replace('INFO', '')))
                : value.includes(3) && (info.includes('DEBUG')) ?
                    (react_1.default.createElement("div", { style: { color: 'orange' } }, info.replace('DEBUG', ''))) : (null))))));
};
exports.default = SupplyUseModelisationProd;
